import React from 'react'

const Arrow = ({ width = 9.45, height = 5.9, gray, golden, up }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 9.45 5.906"
  >
    <path
      fill={golden ? '#b18935' : gray ? '#454E5B' : '#A1A9B4'}
      d="M5,1.181,6.2,0l4.7,4.725L6.2,9.45,5,8.268,8.544,4.725Z"
      transform={`${
        up ? 'translate(0 11) rotate(270)' : 'translate(9.45 -5) rotate(90)'
      }`}
    />
  </svg>
)

export default Arrow
